import { render, staticRenderFns } from "./SysNoticeList.vue?vue&type=template&id=6846eb09&scoped=true&"
import script from "./SysNoticeList.vue?vue&type=script&lang=js&"
export * from "./SysNoticeList.vue?vue&type=script&lang=js&"
import style0 from "./SysNoticeList.vue?vue&type=style&index=0&id=6846eb09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6846eb09",
  null
  
)

export default component.exports